import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';

import AddTitleBar from '../titleBar/addTitleBar';
import { DateData } from '../formikInput/date';
import ActiveVendorBills from './activeVendorBills';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import PaymentModeDropdown from '../dropdowns/paymentModeDropdown';
import BankDropdown from '../dropdowns/bankDropdown';

//Actions 
import { createReceivable } from '../../redux/actions/receivableActions';
import { getBillingCustomerInvoice, getBillingCustomerInvoiceBranch } from '../../redux/actions/customerInvoiceActions';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
import { ERROR_MESSAGES } from '../../config/const';
import { LOCAL_STORAGE } from '../utils/constants';
import { dateFormats } from '../../utils/constant';
import { buttons, fields } from './receivable.constants';
import { useSelector } from "react-redux";
import BranchDropdown from '../dropdowns/branchDropdown';

const AddReceivable = (props) => {


    const { createReceivable, getBillingCustomerInvoice, getBillingCustomerInvoiceBranch, billingCustomerInvoiceData, billingCustomerInvoiceLoading, getSalesOrder } = props;

    //state
    const [customerName, setCustomerName] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [paymentName, setPaymentName] = useState("")
    const [initialize, setInitialize] = useState(false)
    const [branchData, setBranchData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [vendorStateId, setVendorStateId] = useState('');
    const [selectedBranchCode, setSelectedBranchCode] = useState('');
    const [masterState, setMasterState] = useState('');
    const [vendorDetails, setVendorDetails] = useState([]);
    const [customerDetails, setCustomerDetails] = useState({})
    const [customerCode, setCustomerCode] = useState('')
    const [clientBranchCode, setClientBranchCode] = useState('')
    const [branchCode, setBranchCode] = useState('')

    const getCusInvoiceData = useSelector((state) => state.getCustomerInvoiceData.customerInvoice);

    console.log("getCusInvoiceData", getCusInvoiceData?.data)

    const paymentSelected = childData => {

        let addedPaymentMode = paymentData.filter(e => {
            // console.log("Payment Code ", e.paymentModeCode)
            return e.paymentModeCode === childData
        })
        setPaymentName(addedPaymentMode && addedPaymentMode.length > 0 && addedPaymentMode[0].paymentModeName)

        // console.log("ChildData", childData, paymentName, addedPaymentMode)
    }


    let activeCustomerInvoiceData = [];

    billingCustomerInvoiceData && billingCustomerInvoiceData.map((o, i) => {
        let temp = {}
        temp.checkbox = false
        temp.invoiceDate = o.invoice_date
        temp.referenceNo = o.reference_number
        temp.invoiceNo = o.invoice_no
        temp.clientCode = o.client_name
        temp.invoiceDueDate = o.expected_payment_date
        temp.invoiceAmount = o.invoice_amt
        temp.amountDue = o.pending_amt
        temp.invoiceId = o.id
        temp.payment = ''
        temp.tds = ''
        temp.sumOfPaymentTDS = 0


        activeCustomerInvoiceData[i] = temp
    })

    // console.log("VendorBillsData", billingCustomerInvoiceData)

    //Formik
    const initialValues = {
        customerName: customerName,
        customerBranch: selectedBranchCode,
        branch: branchCode,
        paymentAmount: '',
        paymentDate: '',
        paymentMode: '',
        bank: '',
        refNo: '',
        activeCustomerInvoices: activeCustomerInvoiceData,
        activeCustomerInvoicesSelected: [],
        tdsOnBills: [],
        transactionDate: '',
        notes: '',
        finalPayment: '',

    }

    const validateSchema = yup.object().shape({
        customerName: yup.mixed().required(ERROR_MESSAGES.VENDOR_NAME_REQUIRED),
        customerBranch: yup.mixed().required(ERROR_MESSAGES.BRANCH_REQUIRED),
        paymentAmount: yup.mixed().required(ERROR_MESSAGES.PAYMENT_AMOUNT_REQUIRED),
        paymentDate: yup.mixed().required(ERROR_MESSAGES.PAYMENT_DATE_REQUIRED),
        paymentMode: yup.mixed().required(ERROR_MESSAGES.PAYMENT_MODE_REQUIRED),
        refNo: yup.mixed().required(ERROR_MESSAGES.REFERENCE_NO_REQUIRED),
        transactionDate: yup.mixed().required(ERROR_MESSAGES.TRANSACTION_DATE_REQUIRED),
        activeCustomerInvoices: yup.array().of(
            yup.object().shape({
                checkbox: yup.boolean(),
                payment: yup.number().positive().when(['checkbox'], (checkbox, schema) => {
                    return checkbox && checkbox === true
                        ? schema
                            .required(ERROR_MESSAGES.PAYMENT_AMOUNT_REQUIRED)
                            .min(1, ERROR_MESSAGES.AMOUNT_LESS_THAN_ZERO)
                        :
                        schema
                }),
                sumOfPaymentTDS: yup.number().when(['checkbox', 'amountDue'], (checkbox, amountDue, schema) => {
                    return checkbox && checkbox === true
                        ? schema
                            .max(Number(amountDue), ERROR_MESSAGES.AMOUNT_DUE_EXCEEDED_PAYMENT_PLUS_TDS)
                        :
                        schema
                })
            })
        )
    })

    const onSubmit = (values, onSubmitProps) => {
        console.log("1111111111", values)

        const customerNumber = LOCAL_STORAGE.customerNo;
        const userId = LOCAL_STORAGE.userId;

        const invoices = [];
        values.activeCustomerInvoicesSelected.map((product, index) => {
            let temp = {}
            temp.invoice_id = product.invoiceId
            temp.paid_amount = product.payment
            temp.pending_amount = product.amountDue
            temp.tds_paid = product.tds ? product.tds : 0

            invoices[index] = temp
        });

        const createReceivableData = {
            customer_no: customerNumber,
            user_id: userId,
            reference_number: values.refNo,
            client_code: values.customerName,
            client_branch_code: values.customerBranch,
            branch_code: values.branch,
            payment_date: moment(values.paymentDate).format(dateFormats.DD_MM_YYYY),
            transaction_date: moment(values.transactionDate).format(dateFormats.DD_MM_YYYY),
            payment_recieved_date: moment(values.paymentDate).format(dateFormats.DD_MM_YYYY),
            payment_mode_code: values.paymentMode,
            cheque_no: values.chequeNo,
            bank_code: values.bank,
            status_id: "2",
            complete_payment: values.paymentAmount === values.finalPayment ? 1 : 0,
            paid_amount: values.finalPayment,
            payment_amount: values.paymentAmount,
            tds_amount: 0,
            pending_amount: +values.paymentAmount - +values.finalPayment,
            remarks: '',
            invoice_list: invoices,
        };

        createReceivable(createReceivableData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });

    };

    const getBranchData = childData => {
        //console.log("Get Branch Data Called", childData);
        setBranchData(childData)
    };

    const getBranchSelected = childData => {
        setSelectedBranchCode(childData)
        const branchDetails = branchData.find(data => data.billingPartyBranchCode === childData);
        const stateDetails = stateData.find(data => data.stateId === branchDetails && branchDetails.billingPartyBranchStateId);
        // console.log("Branch Value", childData, branchDetails, stateDetails)


        // console.log("branch Details", branchDetails)

        //VendorState from Branch Selected
        setVendorStateId(stateDetails && stateDetails.stateId)
    };

    const getMasterBranchSelected = (branchCode, branchData) => {
        const addedMasterBranchObject = branchData.find(data => data.branchCode === branchCode)
        setMasterState(addedMasterBranchObject.stateId)
    }

    const getVendorDetails = childData => {
        setVendorDetails(childData);
    }

    const getCustomerDetails = childData => {
        setCustomerDetails(childData);
    }

    const handleSearch = () => {
        getBillingCustomerInvoiceBranch && getBillingCustomerInvoiceBranch(customerCode, clientBranchCode, branchCode).then((res) => {
            setInitialize(false)
        })
    }



    return (
        <React.Fragment>
            <AddTitleBar title="New Receivable" LinkName="/receivable" />
            <div className="m-2">
                <Formik
                    enableReinitialize={initialize}
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                        <>
                            <Segment>
                                <div className="ui form tiny">
                                    <FormUi.Group >
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">{fields.customer.title}<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik
                                                component={BillingPartyDropdown}
                                                name="customerName"
                                                placeholder={fields.customer.title}
                                                getBranchData={getBranchData}
                                                getVendorDetails={getVendorDetails}
                                                getCustomerSalesOrder={getSalesOrder}
                                                setCustomerName={setCustomerName}
                                                getCustomerDetails={getCustomerDetails}
                                                setInitialize={setInitialize}
                                                SOPagination={true}
                                                // getBillingCustomerInvoice={getBillingCustomerInvoice} 
                                                setCustomerCode={(data) => setCustomerCode(data)}
                                            />
                                            {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                        </FormUi.Field>

                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">{fields.branch.title}<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik component={CustomerBranchDropdown}
                                                name="customerBranch"
                                                branchData={branchData}
                                                getBranchSelected={getBranchSelected}
                                                getCustomerSalesOrder={getSalesOrder}

                                                setClientBranchCode={(data) => setClientBranchCode(data)}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">Branch<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik
                                                component={BranchDropdown}
                                                name="branch"
                                                placeholder="Branch"
                                                getMasterBranchSelected={getMasterBranchSelected}
                                                getCustomerSalesOrder={getSalesOrder}
                                                setBranchCode={(data) => setBranchCode(data)}
                                            />
                                            {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                        </FormUi.Field>

                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <Button disabled={
                                                values.customerName && values.customerBranch && values.branch ? false : true
                                            } onClick={handleSearch} size='mini' primary>Search</Button>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>


                                    </FormUi.Group>



                                    {getCusInvoiceData?.data && getCusInvoiceData?.data.length > 0 && customerName ?
                                        <>
                                            {billingCustomerInvoiceLoading && values.customerName ? <LoadingPlaceholder /> : <ActiveVendorBills />}

                                            <FormUi.Group className="mt-4">
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.paymentAmount.title}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik name="paymentAmount" placeholder={fields.paymentAmount.title} />
                                                    {touched.paymentAmount && errors.paymentAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentAmount}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.paymentDate.title}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        name={`paymentDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholderText={fields.paymentDate.placeholder}
                                                        selected={values.paymentDate}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />
                                                    {touched.paymentDate && errors.paymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentDate}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.paymentMode.title}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={PaymentModeDropdown} name="paymentMode" placeholder={fields.paymentMode.title} setPaymentData={setPaymentData} paymentSelected={paymentSelected} />
                                                    {touched.paymentMode && errors.paymentMode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentMode}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                            </FormUi.Group>
                                            <FormUi.Group>
                                                {paymentName === "CASH" ?
                                                    ""
                                                    :
                                                    <>
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">{fields.bank.title}</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="4">
                                                            <Fieldmik component={BankDropdown} name="bank" placeholder={fields.bank.title} />
                                                            {touched.bank && errors.bank ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.bank}</strong> : ''}
                                                        </FormUi.Field>
                                                        {paymentName === "CHEQUE" ?
                                                            <>
                                                                <FormUi.Field width="1" />
                                                                <FormUi.Field width="3">
                                                                    <label className="labelName mt-2">{fields.chequeNo.title}</label>
                                                                </FormUi.Field>
                                                                <FormUi.Field width="4">
                                                                    <Fieldmik name="chequeNo" placeholder={fields.chequeNo.title} />
                                                                    {touched.chequeNo && errors.chequeNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.chequeNo}</strong> : ''}
                                                                </FormUi.Field>
                                                            </> : ""
                                                        }
                                                    </>}
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.refNo.title}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik name="refNo" placeholder={fields.refNo.title} />
                                                    {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.transactionDate.title}e</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        name={`transactionDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholderText={fields.transactionDate.placeholder}
                                                        selected={values.transactionDate}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />
                                                    {touched.transactionDate && errors.transactionDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.transactionDate}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            <FormUi.Group className="mt-4">
                                                <FormUi.Field width="8" />
                                                <FormUi.Field width='3'>
                                                    <b style={{ fontWeight: "600" }}>{fields.finalAmount.title}</b>
                                                </FormUi.Field>
                                                <FormUi.Field width='3'>
                                                    <b style={{ fontWeight: "600" }}>{fields.currencySymbol} {Number(values.finalPayment).toFixed(2)}</b>
                                                </FormUi.Field>
                                            </FormUi.Group>

                                        </>
                                        :
                                        ''
                                    }


                                </div>
                            </Segment>
                            {getCusInvoiceData?.data && getCusInvoiceData?.data.length > 0 ?
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>{buttons.submit}</Button></center>
                                :
                                ''
                            }

                        </>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = state => ({
    billingCustomerInvoiceData: state.getCustomerInvoiceData.customerInvoice.data,
    billingCustomerInvoiceLoading: state.getCustomerInvoiceData.isLoading,
})


export default connect(mapStatetoProps, { createReceivable, getBillingCustomerInvoice, getBillingCustomerInvoiceBranch })(AddReceivable)


